import { ActionsV2__communicationType } from 'app/promotionsv2/actions/actions-edit/store/actionsV2-FormStateModel';
import { MessageStructuresModel } from '../../list/models/messageStructuresList.models';
import { PromotionTypes } from '@prisma/components/generic-select-promotion-types/generic-select-promotion-types.component';

export interface MessageStructuresItem {
  id: number;
  code: string;
  name: string;
  promotionType: PromotionTypes;
  promotionalProcessId: number;
  promotionalProcess?: string;
  communicationType: ActionsV2__communicationType;
  defaultMessageStructureId: number;
  isDefaultMessageStructure?: boolean;
  chips: SelectedChips[];
}

export type MessageStructureItemToBe = Omit<MessageStructuresItem, 'defaultMessageStructureId'> &
  Required<Pick<MessageStructuresItem, 'isDefaultMessageStructure'>>;

export interface MessageStructuresFormModel {
  mainData: MainDataTab;
  messageStructure: MessageStructureTab;
  originalCode: string;
}
export enum MessageStructuresTabs {
  MAIN_DATA = 'mainData',
  MESSAGE_STRUCTURE = 'messageStructure',
}
export interface MainDataTab {
  id: number;
  code: string;
  name: string;
  promotionalProcessId: number;
  promotionTypeId: number;
  communicationType: ActionsV2__communicationType;
  isDefaultMessageStructure: boolean;
  defaultMessageStructureId: number;
}

export interface MessageStructureTab {
  chips: SelectedChips[];
}

export interface ChipModel {
  id: number;
  chipText: string; // “Llevate”
  chipMenuOrder: number; // 0 (Estaría arriba de todo)
  menuSectionType: MenuSectionTypeEnum; // key para Nombre de la sección (Texto de apoyo inicial)
  example: string; // “Coca Cola” (En caso de ítems)
  chipType: ChipTypesEnum; //string
  order?: number;
  uniqueId?: string; // interno de front
  tagId?: number; // id de tag por ejemplo el id del tag 'Marca' para despues filtrar los tagValueIds
  completedText?: string;
  selectedChipId?: number;
  selectedItemIds?: number[];
  selectedTagValueIds?: number[];
}

export interface ChipGroup {
  menuSectionType: MenuSectionTypeEnum;
  chips: ChipModel[];
}

export interface SelectedChips {
  id: number;
  order: number;
}

export interface ActionMessageStructure {
  messageStructureId: number;
  structureValues: StructureValue[];
}

export interface StructureValue {
  chipId: number;
  chipOrder: number;
  selectedValue: {
    id: number;
    text?: string;
  };
}

export type MessageStructureFormModelToBe = Omit<
  MessageStructuresModel,
  'promotionalProcess' | 'promotionType' | 'defaultMessageStructureId'
>;

export enum ChipTypesEnum {
  selectableText = 'SelectableText',
  items = 'Items',
  loyaltyProgram = 'LoyaltyProgram',
  minimumQuantity = 'MinimumQuantity',
  payUnits = 'PayUnits',
  freeText = 'FreeText',
  value = 'Value',
  fixedText = 'FixedText',
  selectableTag = 'SelectableTag',
  giftValue = 'GiftValue',
  giftUnits = 'GiftUnits',
  giftDiscount = 'GiftDiscount',
  giftItems = 'ItemsGift',
}

export enum MenuSectionTypeEnum {
  initialSupportText = 'InitialSupportText',
  finalSupportText = 'FinalSupportText',
  quantity = 'Quantity',
  items = 'Items',
  connectors = 'Connectors',
  price = 'Price',
  freeText = 'FreeText',
  variableText = 'VariableText',
  tags = 'Tags',
  extra = 'Extra',
}
